import { useContext, useEffect, useState } from "react";
import { TabelaStyled } from "../../Styles/admin";
import { Footer } from "../../components/Footer";
import { Header, HeaderMobil } from "../../components/Header";
import { LogoBG } from "../../components/logoBG";
import { apiSae } from "../../services/api";
import {
  ModalsDesableUser,
  ModalsCreateUser,
  ModalsUpdateEstacao,
  ModalsUpdateUser,
  ModalResetGtw,
} from "./modals";
import { AdminContext } from "../../Context/ContextAdmin";
import { HomeContext } from "../../Context/ContextHome";

export const AdminUsuarios = () => {
  const {
    modalCreateUser,
    setModalCreateUser,
    modalUpdateUser,
    setModalUpdateUser,
    modalDesableUser,
    setDesableUser,
    users,
    setUsers,
    headerApi,
    selecionaUsuario,
    setSelecionaUsuario,
    exibirErro,
    modalResetGtwOn,
    setModalResetGtwOn,
  } = useContext(AdminContext);

  const { userOn } = useContext(HomeContext);

  const [salveGtwUser, setSalveGtwUser] = useState();

  const renderUsers = async () => {
    try {
      const Response = await apiSae.get("users/LeituraTodos", headerApi);
      setUsers(Response.data);
    } catch (error) {
      exibirErro("Falha ao carregar usuários");
    }
  };

  useEffect(() => {
    renderUsers();
  }, [userOn]);

  return (
    <TabelaStyled>
      {modalCreateUser && <ModalsCreateUser />}
      {modalUpdateUser && <ModalsUpdateUser />}
      {modalDesableUser && <ModalsDesableUser />}
      {modalResetGtwOn && <ModalResetGtw gtwId={salveGtwUser} />}
      <Header pgRedireciona="/admin" />
      <HeaderMobil pgRedireciona="/admin" />
      <div className="bloco">
        <h3>Lista de Usuário</h3>
        <div className="blocoTabela">
          <table className="blueTable">
            <thead>
              <tr>
                <th>Usuário</th>
                <th>Nome Completo</th>
                <th>E-mail</th>
                <th>Matrícula</th>
                <th>Acesso</th>
                <th>GTW</th>
                <th>Ativo</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => {
                if (!user) return null; // Verificação se o usuário existe
                return (
                  <>
                    <span
                      className={`off ${user.online && "on"} ${
                        user.gateway && "gtw"
                      }`}
                      onClick={() => {
                        if (user.online && user.gateway) {
                          setSalveGtwUser(user.gateway);
                          setModalResetGtwOn(true);
                        }
                      }}
                    >
                      {user.online && user.gateway && "Reniciar Gtw"}
                    </span>
                    <tr
                      key={user.id}
                      onClick={() => {
                        setSelecionaUsuario([user.id, user.is_active]);
                      }}
                      className={
                        selecionaUsuario[0] === user.id ? "seleciona" : ""
                      }
                    >
                      <td>{user.usuario}</td>
                      <td>{user.nome}</td>
                      <td>{user.email}</td>
                      <td>{user.matricula}</td>
                      <td>{user.role}</td>
                      <td>{user.gateway ? user.gateway : "Não"}</td>
                      <td>{user.is_active ? "Sim" : "Não"}</td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="Botao">
          <button onClick={() => setModalCreateUser(true)}>Adicionar</button>
          <button
            onClick={() => {
              if (selecionaUsuario && selecionaUsuario.length > 0) {
                setModalUpdateUser(true);
              } else {
                exibirErro("Por favor, selecione um usuário para editar.");
              }
            }}
          >
            Editar
          </button>
          <button onClick={() => setDesableUser(true)}>
            {selecionaUsuario[1] ? "Desativar" : "Ativar"}
          </button>
        </div>
      </div>
      <LogoBG />
      <Footer relative={true} background={true} />
    </TabelaStyled>
  );
};
